import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import GoogleMapReact from 'google-map-react';
import { platformSettingsService } from '../services/central-api/platform-settings';
import { UnistylesRuntime } from 'react-native-unistyles';

export default function HeatMap({ posList }: { posList: LatLng[]; }) {
    const styles = getStyles();
    const [defaultCenter, setDefaultCenter] = useState<GoogleMapReact.Coords | undefined>();
    const [defaultZoom, setDefaultZoom] = useState<number>(11);
    const [bounds, setBounds] = useState<google.maps.LatLngBounds>();
    const [map, setMap] = useState<google.maps.Map>();
    const { data } = platformSettingsService.useMapCentralPoint();

    useEffect(() => {
        if (data) {
            setDefaultCenter({ lat: data.latitude, lng: data.longitude });
            setDefaultZoom(data.zoom);
        }
    }, [data]);

    useEffect(() => {
        if (!map || !bounds) {
            return;
        }
        if (posList.length) {
            posList.forEach((pos) => {
                bounds.extend(new google.maps.LatLng(pos.lat, pos.lng));
            });
            map.fitBounds(bounds);
        } else if (defaultCenter) {
            map.setCenter(defaultCenter);
            map.setZoom(defaultZoom);
        }

    }, [bounds, map, posList]);

    return (
        <View style={styles.mapContainer}>
            {defaultCenter &&
                <GoogleMapReact
                    center={defaultCenter}
                    heatmap={{
                        positions: posList,
                        options: {
                            opacity: 0.8
                        }
                    }}
                    draggable={true}
                    defaultZoom={defaultZoom}
                    options={() => ({
                        streetViewControl: true,
                        fullscreenControl: false,
                        zoomControl: true,
                        styles: UnistylesRuntime.themeName === 'light' || UnistylesRuntime.themeName == 'lightAlt' ? [{
                            featureType: 'poi',
                            elementType: 'labels',
                            stylers: [{ visibility: 'off' }],
                        },
                        {
                            featureType: 'transit',
                            stylers: [{ visibility: 'off' }],
                        }] : [
                            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
                            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
                            { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
                            { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
                            { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
                            {
                                featureType: 'administrative.locality',
                                elementType: 'labels.text.fill',
                                stylers: [{ color: '#d59563' }],
                            },
                            {
                                featureType: 'road',
                                elementType: 'geometry',
                                stylers: [{ color: '#38414e' }],
                            },
                            {
                                featureType: 'road',
                                elementType: 'geometry.stroke',
                                stylers: [{ color: '#212a37' }],
                            },
                            {
                                featureType: 'road',
                                elementType: 'labels.text.fill',
                                stylers: [{ color: '#9ca5b3' }],
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'geometry',
                                stylers: [{ color: '#746855' }],
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'geometry.stroke',
                                stylers: [{ color: '#1f2835' }],
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'labels.text.fill',
                                stylers: [{ color: '#f3d19c' }],
                            },
                            {
                                featureType: 'water',
                                elementType: 'geometry',
                                stylers: [{ color: '#17263c' }],
                            },
                            {
                                featureType: 'water',
                                elementType: 'labels.text.fill',
                                stylers: [{ color: '#515c6d' }],
                            },
                            {
                                featureType: 'water',
                                elementType: 'labels.text.stroke',
                                stylers: [{ color: '#17263c' }],
                            },
                        ]
                    })}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }: { map: google.maps.Map; maps: typeof google.maps; }) => {
                        setBounds(new maps.LatLngBounds());
                        setMap(map);
                    }}>
                </GoogleMapReact>}
        </View >
    );
}

function getStyles() {
    return StyleSheet.create({
        mapContainer: {
            flex: 1
        }
    });
}
